import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormButtons } from '../index.styled'
import Button from '../../buttons/Button'
import FormButtonSave from '../../buttons/FormButtonSave'

const FormControls = ({ updateMode, handleSubmit, handleReset, bottom, submitDisabled, children, zIndex, className, keyButton, cancelKeyButton, disableProccesing }) => {
	const { t } = useTranslation()
	const layout = (bottom ? 'bottom ' : '') + (className ? `${className} ` : '')

	return (
		<FormButtons className={layout}>
			<Button name="clear" icon="clear" text={t('buttons.controls.cancel')} keyButton={cancelKeyButton || 'F3'} onClick={handleReset} testId="button-reset" zIndex={zIndex} />
			{children}
			<FormButtonSave {...{ updateMode, zIndex, onClick: handleSubmit, disabled: submitDisabled, keyButton, disableProccesing }} />
		</FormButtons>
	)
}

FormControls.displayName = 'FormControls'
export default FormControls
